// A diocese gets itself as parent_network_id, so filtering by parent includes the diocese office too
export const tagSentryNetwork = ({ networkID, parentNetworkID, isParent }) => {
  if (!window.Sentry?.setTag) {
    return;
  }

  window.Sentry.setTag("network_id", networkID);

  const parentID = isParent ? networkID : parentNetworkID;
  if (parentID) {
    window.Sentry.setTag("parent_network_id", parentID);
  }
};
